(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var hero = document.getElementById('bc-scroll-hero');
  var canvas = document.getElementById('bc-canvas');
  if (!hero || !canvas) return;

  var ctx = canvas.getContext('2d');
  var W, H, DPR;
  var drops = [];
  var ripples = [];
  var lastDrop = 0;
  var scrollProgress = 0;
  var motionTime = 0;

  function resize() {
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    W = canvas.offsetWidth;
    H = canvas.offsetHeight;
    canvas.width = Math.round(W * DPR);
    canvas.height = Math.round(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  resize();
  window.addEventListener('resize', resize);

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function spawnDrop(progress) {
    var large = Math.random() > 0.5;
    drops.push({
      x: W * (0.18 + Math.random() * 0.64),
      y: -40 - Math.random() * 120,
      vy: large ? (1.6 + Math.random() * 1.2) : (2.2 + Math.random() * 1.6),
      vx: (Math.random() - 0.5) * 0.35,
      r: large ? (8 + Math.random() * 10) : (4 + Math.random() * 6),
      stretch: 1.2 + Math.random() * 1.2,
      hueShift: Math.random() > 0.72,
      wobble: Math.random() * Math.PI * 2,
      life: 1,
      glossy: 0.18 + Math.random() * 0.18
    });
  }

  function spawnRipple(x, y, size) {
    ripples.push({
      x: x,
      y: y,
      r: size * 0.45,
      maxR: 70 + Math.random() * 80,
      life: 1,
      width: 1.2 + Math.random() * 1.4
    });
  }

  function drawBackdrop(progress) {
    var bg = ctx.createLinearGradient(0, 0, 0, H);
    bg.addColorStop(0, '#102019');
    bg.addColorStop(0.38, '#0c1813');
    bg.addColorStop(1, '#07110c');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);

    var glow1 = ctx.createRadialGradient(W * 0.5, H * 0.2, 0, W * 0.5, H * 0.2, W * 0.55);
    glow1.addColorStop(0, 'rgba(34, 68, 52, 0.40)');
    glow1.addColorStop(0.4, 'rgba(22, 49, 38, 0.18)');
    glow1.addColorStop(1, 'rgba(0, 0, 0, 0)');
    ctx.fillStyle = glow1;
    ctx.fillRect(0, 0, W, H);

    var glow2 = ctx.createRadialGradient(W * 0.8, H * 0.18, 0, W * 0.8, H * 0.18, W * 0.18);
    glow2.addColorStop(0, 'rgba(196, 168, 106, 0.08)');
    glow2.addColorStop(1, 'rgba(196, 168, 106, 0)');
    ctx.fillStyle = glow2;
    ctx.fillRect(0, 0, W, H);

    var hazeAlpha = Math.max(0, (progress - 0.18) * 0.22);
    if (hazeAlpha > 0) {
      for (var i = 0; i < 4; i++) {
        var y = H * (0.22 + i * 0.16 + Math.sin(motionTime * 0.35 + i) * 0.018);
        var haze = ctx.createLinearGradient(0, y, 0, y + 120);
        haze.addColorStop(0, 'rgba(34, 60, 48, 0)');
        haze.addColorStop(0.5, 'rgba(34, 60, 48,' + hazeAlpha + ')');
        haze.addColorStop(1, 'rgba(34, 60, 48, 0)');
        ctx.fillStyle = haze;
        ctx.fillRect(0, y - 20, W, 120);
      }
    }
  }

  function drawSurface(surfaceY) {
    ctx.save();

    var oilGrad = ctx.createLinearGradient(0, surfaceY - 12, 0, H);
    oilGrad.addColorStop(0, 'rgba(22, 35, 28, 0.12)');
    oilGrad.addColorStop(0.08, 'rgba(31, 51, 40, 0.42)');
    oilGrad.addColorStop(0.22, 'rgba(18, 28, 22, 0.76)');
    oilGrad.addColorStop(1, 'rgba(7, 17, 12, 0.96)');
    ctx.fillStyle = oilGrad;
    ctx.fillRect(0, surfaceY - 12, W, H - surfaceY + 12);

    var sheen = ctx.createLinearGradient(0, surfaceY - 3, 0, surfaceY + 12);
    sheen.addColorStop(0, 'rgba(214, 195, 143, 0)');
    sheen.addColorStop(0.45, 'rgba(214, 195, 143, 0.18)');
    sheen.addColorStop(0.7, 'rgba(83, 119, 93, 0.14)');
    sheen.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = sheen;
    ctx.fillRect(0, surfaceY - 8, W, 20);

    ctx.restore();
  }

  function drawDrops(surfaceY) {
    drops = drops.filter(function(d) { return d.y < H + 120 && d.life > 0; });

    drops.forEach(function(d, index) {
      d.wobble += 0.035;
      d.x += d.vx + Math.sin(d.wobble) * 0.08;
      d.y += d.vy;
      d.life -= 0.0008;

      if (d.y < surfaceY) {
        ctx.save();
        ctx.translate(d.x, d.y);
        ctx.rotate(Math.sin(d.wobble) * 0.08);

        var rr = d.r;
        var rx = rr * 0.9;
        var ry = rr * d.stretch;

        var grad = ctx.createRadialGradient(-rr * 0.2, -ry * 0.4, 0, 0, 0, ry * 1.15);
        if (d.hueShift) {
          grad.addColorStop(0, 'rgba(214, 187, 118, 0.95)');
          grad.addColorStop(0.28, 'rgba(130, 101, 45, 0.88)');
          grad.addColorStop(0.72, 'rgba(56, 84, 60, 0.92)');
          grad.addColorStop(1, 'rgba(14, 24, 18, 0)');
        } else {
          grad.addColorStop(0, 'rgba(88, 122, 93, 0.88)');
          grad.addColorStop(0.38, 'rgba(48, 74, 56, 0.92)');
          grad.addColorStop(0.78, 'rgba(17, 28, 21, 0.95)');
          grad.addColorStop(1, 'rgba(14, 24, 18, 0)');
        }

        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = 'rgba(255, 241, 200,' + d.glossy + ')';
        ctx.beginPath();
        ctx.ellipse(-rr * 0.22, -ry * 0.32, rr * 0.16, ry * 0.18, -0.4, 0, Math.PI * 2);
        ctx.fill();

        ctx.restore();
      } else {
        spawnRipple(d.x, surfaceY + (Math.random() * 4 - 2), d.r * d.stretch);
        d.life = 0;
        drops[index] = d;
      }
    });
  }

  function drawRipples() {
    ripples = ripples.filter(function(rp) { return rp.life > 0; });

    ripples.forEach(function(rp) {
      rp.r += 0.85;
      rp.life -= 0.0095;

      ctx.save();
      ctx.beginPath();
      ctx.ellipse(rp.x, rp.y, rp.r * 1.55, rp.r * 0.42, 0, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(166, 148, 100,' + (rp.life * 0.22) + ')';
      ctx.lineWidth = rp.width;
      ctx.stroke();

      ctx.beginPath();
      ctx.ellipse(rp.x, rp.y + 1, rp.r * 1.08, rp.r * 0.28, 0, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(84, 117, 91,' + (rp.life * 0.18) + ')';
      ctx.lineWidth = Math.max(0.8, rp.width - 0.4);
      ctx.stroke();
      ctx.restore();
    });
  }

  function tick(now) {
    requestAnimationFrame(tick);
    motionTime += 0.012;

    var p = scrollProgress;
    drawBackdrop(p);

    var surfaceY = lerp(H * 0.82, H * 0.58, Math.min(1, Math.max(0, (p - 0.18) / 0.5)));
    drawSurface(surfaceY);

    var dropRate = 0;
    if (p > 0.18 && p <= 0.55) {
      dropRate = 160 + ((p - 0.18) / 0.37) * 260;
    } else if (p > 0.55) {
      dropRate = 420 + ((p - 0.55) / 0.45) * 420;
    }

    if (dropRate > 0 && now - lastDrop > (2600 / dropRate)) {
      spawnDrop(p);
      if (Math.random() > 0.72) spawnDrop(p);
      lastDrop = now;
    }

    drawRipples();
    drawDrops(surfaceY);

    var vignette = ctx.createRadialGradient(W * 0.5, H * 0.48, H * 0.12, W * 0.5, H * 0.48, H * 0.8);
    vignette.addColorStop(0, 'rgba(0,0,0,0)');
    vignette.addColorStop(1, 'rgba(0,0,0,0.26)');
    ctx.fillStyle = vignette;
    ctx.fillRect(0, 0, W, H);
  }

  requestAnimationFrame(tick);

  var lines = [
    document.getElementById('bc-line-1'),
    document.getElementById('bc-line-2'),
    document.getElementById('bc-line-3'),
    document.getElementById('bc-line-4'),
    document.getElementById('bc-line-5')
  ];
  var cta = document.getElementById('bc-cta');
  var totalSteps = lines.length + 1;

  function onScroll() {
    var rect = hero.getBoundingClientRect();
    var heroHeight = hero.offsetHeight;
    var scrolled = -rect.top;
    var progress = scrolled / (heroHeight - window.innerHeight);
    progress = Math.max(0, Math.min(1, progress));
    scrollProgress = progress;

    var textStart = 0.58;
    var textRange = 0.42;
    var textProgress = Math.max(0, (progress - textStart) / textRange);
    var step = textProgress * totalSteps;

    lines.forEach(function(line, i) {
      if (step >= i + 0.25) line.classList.add('visible');
      else line.classList.remove('visible');
    });

    if (step >= lines.length + 0.2) cta.classList.add('visible');
    else cta.classList.remove('visible');
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();
})();
